import { helper } from '@ember/component/helper';
import { MeUserId } from 'volta/models/user';

function isMeId([id]: string[] /*, hash*/) {
  return id === MeUserId;
}

const isMeIdHelper = helper(isMeId);
export default isMeIdHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'is-me-id': typeof isMeIdHelper;
  }
}
